import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ReferralSection } from "@/components/ReferralSection";
import { ArrowLeft } from "lucide-react";
import { useAuth } from "@/App";

export const ReferralsPage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto p-6">
        <Button 
          variant="ghost" 
          onClick={() => navigate(-1)}
          className="mb-4"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back
        </Button>
        
        <h1 className="text-2xl font-bold text-gray-900 mb-6">Refer & Earn</h1>
        
        <ReferralSection />
      </div>
    </div>
  );
};

export default ReferralsPage;
